import { render, staticRenderFns } from "./CakeColourPicker.vue?vue&type=template&id=8016db8e&"
import script from "./CakeColourPicker.vue?vue&type=script&lang=js&"
export * from "./CakeColourPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports